import { Address, InternationalPhoneData } from '@electricjs/arc';

import { Application } from '@/types/applications';
import { Group } from '@/types/groups';

export enum OnboardingStep {
  Demographics = 1,
  EmployeeInformation = 2,
  LicenseSelection = 3,
  Onboarding = 4,
  Applications = 5,
}

export enum OffboardingStep {
  Applications = 1,
  Hardware = 2,
}

export enum HiringStatus {
  New = 'new',
  Existing = 'existing',
  Hris = 'hris',
}

export const LicenseAction = {
  GrantLicense: 'grantLicense',
  NoLicense: 'noLicense',
} as const;

export type LicenseAction = (typeof LicenseAction)[keyof typeof LicenseAction];

export const ITSetupOption = {
  ApplicationsAndHardware: 'applicationsAndHardware',
  ApplicationsOnly: 'applicationsOnly',
  HardwareOnly: 'hardwareOnly',
  GrantLicenseOnly: 'grantLicenseOnly',
  NoLicenseNeeded: 'noLicenseNeeded',
} as const;

export type ITSetupOption = (typeof ITSetupOption)[keyof typeof ITSetupOption];

export type OnboardingFormData = {
  demographics: {
    firstName: string;
    lastName: string;
    personalEmail: string;
    address: Address;
    phone: InternationalPhoneData | null;
  };
  employeeInformation: {
    startDate: Date | null;
    jobTitle: string;
    email: string;
    manager?: { value: string; label: string } | null;
  };
  organizationPackageId: string | undefined;
  groups: Group[];
  currentStep: OnboardingStep;
  hiringStatus: HiringStatus;
  needsApplications: boolean;
  needsHardware: boolean;
  licenseAction?: LicenseAction;
  watchers: string[];
  notifyManager?: boolean;
  additionalApps: Application[];
  excludedApps: Application[];
};

export const PackageFeatures = {
  DeviceManagement: 'DeviceManagement',
  DeviceProcurement: 'DeviceProcurement',
  EmployeeManagement: 'EmployeeManagement',
  AppManagement: 'AppManagement',
  EmployeeSupport: 'EmployeeSupport',
} as const;

export type FeatureKey = keyof typeof PackageFeatures;
